<!--test.vue-->
<template>
  <div class="qk-video">
    <video
      v-if="muted"
      :src="$utils.changeURLArg(videoSrc, 't', date)"
      :ref="refId"
      :id="uuid + '_video'"
      muted
      preload="auto"
      :autoplay="autoPlay"
      :loop="loop"
      x5-playsinline="true"
      playsinline="true"
      webkit-playsinline="true"
      :controls="false"
    ></video>
    <video
      v-else
      :src="$utils.changeURLArg(videoSrc, 't', date)"
      :ref="refId"
      :id="uuid + '_video'"
      preload="auto"
      :autoplay="autoPlay"
      :loop="loop"
      x5-playsinline="true"
      playsinline="true"
      webkit-playsinline="true"
      :controls="false"
    ></video>
  </div>
</template>

<script>
export default {
  name: "QkVideo", // 这个名字很重要，它就是未来的标签名<qk-text></qk-text>
  props: {
    videoSrc: {
      type: String,
      default:
        "https://sct-ieds.oss-cn-shenzhen.aliyuncs.com/h5-show/sct/entry/v3/entry_pc.mp4",
    },
    loop: {
      type: Boolean,
      default: false,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      date: new Date().getTime(),
      refId: new Date().getTime() + "_video",
    };
  },
  created() {
    console.log(this.display, this.muted, "created !!");
  },
  beforeDestroy() {
    // this.$refs[this.refId].src = "";
  },
  methods: {
    playFail() {
      window.removeEventListener("click", this.playFail);
      this.play();
    },
    play() {
      // 安卓微信 无法自动播放 todo...
      setTimeout(() => {
        const id = this.uuid + "_video";
        const dom = document.getElementById(id);
        if (dom && dom != null) {
          console.log(`video play:${id}`, dom.src, dom);
          dom.pause();
          const playPromise = dom.play();
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                console.log("video play success");
              })
              .catch((e) => {
                console.log("video play fail:", e);
                window.addEventListener("click", this.playFail);
              });
          }
        }
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.qk-video {
  width: 100%;
  height: 100%;
}
video {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  padding: 0;
  margin: 0;
}
</style>
